import { IRole } from './../models/IRole';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class RoleService {
  public role: Subject<IRole> = new Subject<IRole>();
  public roles: IRole[];

  constructor(private baseService: BaseService) { }

  changeRole(role: IRole) {
    this.role.next(role);

  }
  getRole(): Observable<IRole> {
    return this.role;
  }

  getRoles() {
    return this.baseService.sendHttpGet('/admin/getroles');
  }
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/role.service.ts